import icon from 'components/icon/paths'
import { IconProps } from './types'

const Icon = ({ size = 24, color = 'currentColor', name, fillRule, viewBox, ...rest }: IconProps) => (
  <svg viewBox={viewBox ?? `0 0 ${size} ${size}`} width={size} height={size} {...rest}>
    {typeof icon[name] === 'string' ? <path d={icon[name] as string} fill={color} fillRule={fillRule} /> : icon[name]}
  </svg>
)

export default Icon
